<template>
  <div
    class="air-marker"
    :style="{ '--color': color, '--bg-color': bgColor, '--iconColor': iconColor }"
    @click="handleClick"
  >
    <div
      class="air-icon-wrap"
      :class="[animate, deviceFlag == 'outer' ? 'air-icon-wrap-dashed' : '']"
    >
      <i v-if="icon !== 'icon-custom'" :class="['air-icon iconfont', icon]"></i>
      <div v-else class="air-icon-text" :class="isOpen ? 'normal' : ''">{{ $t('毒') }}</div>
    </div>
    <div class="air-base">
      <img :src="`/static/image/air-monitor/${state}-base.png`" alt="" />
    </div>

    <div class="air-btn" v-if="hasSwitch" @click="onSwitch(isOpen, $event)">
      <svg v-if="!isOpen" class="icon svg-icon" aria-hidden="true">
        <use xlink:href="#icon-btn-off"></use>
      </svg>

      <svg v-else class="icon svg-icon" aria-hidden="true">
        <use xlink:href="#icon-btn-on"></use>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      // bio chemical-weapons fan leaf-2 nuclide gas-mask
      default: ''
    },
    deviceFlag: {
      type: String,
      default: ''
    },
    state: {
      type: String,
      default: ''
    },
    state3: {
      type: String,
      default: ''
    },
    hasSwitch: {
      type: Boolean,
      default: false
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    animate: {
      type: Array,
      default: () => []
    },
    onClick: {
      type: Function,
      default: () => () => {}
    },
    onSwitch: {
      type: Function,
      default: () => () => {}
    }
  },
  data() {
    return {};
  },
  computed: {
    bgColor() {
      const dict = {
        normal: '#123313',
        alarm: '#370707',
        fault: '#673b12',
        offline: '#262626'
      };

      return dict[this.state] || dict.offline;
    },
    color() {
      const dict = {
        normal: '#5cff5e',
        alarm: '#ff3939',
        fault: '#fe902d',
        offline: '#c4c4c4'
      };

      return dict[this.state];
    },
    iconColor() {
      const dict = {
        normal: '#ffffff',
        offline: '#c4c4c4'
      };

      return dict[this.state3];
    }
  },
  methods: {
    handleClick() {
      const el = this.$el;
      this.onClick(el);
    },
    dispose() {
      // if appendToBody is true, remove DOM node after destroy
      if (this.$el && this.$el.parentNode) {
        this.$el.parentNode.removeChild(this.$el);
      }
    }
  }
};
</script>

<style lang="scss">
.air-marker {
  --color: #c4c4c4;
  --size: 80px;
  --base-size: 28px;

  width: var(--size);
  height: calc(var(--size) + var(--base-size));

  transform: translate(-50%, -100%);

  opacity: 0.7;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  position: absolute;
  left: 0;
  top: 0;

  cursor: pointer;

  * {
    box-sizing: border-box;
  }
  .air-icon-wrap-dashed {
    border-style: dashed !important;
  }

  .air-icon-wrap {
    width: var(--size);
    height: var(--size);
    border: 8px solid var(--color);
    border-radius: 50%;

    position: relative;

    background-color: var(--bg-color);

    display: flex;
    justify-content: center;
    align-items: center;

    .air-icon {
      font-size: 50px;
      color: var(--iconColor) !important;
    }

    @keyframes rotate {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }

    @keyframes breathing {
      0% {
        opacity: 0.3;
      }
      50% {
        opacity: 1;
      }
      100% {
        opacity: 0.3;
      }
    }

    @keyframes scale {
      0% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.2);
      }
      100% {
        transform: scale(1);
      }
    }

    &.scale {
      .air-icon {
        animation: scale 2s ease-in-out infinite;
      }
    }

    &.rotate {
      .air-icon {
        animation: rotate 10s linear infinite;
      }
    }

    &.breathing {
      .air-icon {
        animation: breathing 2s ease-in-out infinite;
      }
    }
  }

  .air-base {
    width: 100%;
    height: var(--base-size);

    display: flex;
    justify-content: center;

    img {
      height: 100%;
      object-fit: scale-down;
    }
  }

  .air-btn {
    position: absolute;
    right: 0;
    top: 50%;
    width: 30px;
    height: 30px;
    font-size: 18px;

    svg {
      width: 100%;
      height: 100%;
    }
  }

  .air-icon-text {
    font-size: 36px;
    font-weight: bold;

    &::after {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      width: 100%;
      height: 5px;
      background: var(--color);
      transform: translateY(-50%) rotate(45deg);
    }
  }

  .normal {
    animation: scale1 2s ease-in-out infinite alternate;
  }

  @keyframes scale1 {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.2);
    }
    100% {
      transform: scale(1);
    }
  }
}
</style>
